import React, {useEffect, useState} from "react";
import largeLogo2 from '../../../images/large-logo-2.png';
import logo2 from '../../../images/logo2.png';
import './RegistrationMobile.css';
import axios from "axios";
import config from "../../../config";
import {useTranslation} from "react-i18next";

interface RegistrationMobileProps {
    fields: any
    nextStep(step: number): void
    registrationFormFilled: boolean
    setRegistrationFormFilled(state: boolean): void
    registrationData: any
    setRegistrationData(data: any): void
}

function RegistrationMobile(props: RegistrationMobileProps) {
    const { t, i18n } = useTranslation();

    const [currentStep, setCurrentStep] = useState<number>(1);
    const [name, setName] = useState('');
    const [yearOfBirth, setYearOfBirth] = useState<number>();
    const [selectedGender, setSelectedGender] = useState('');
    const [requiredFiledError, setRequiredFiledError] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [loaderIsActive, setLoaderIsActive] = useState(false);

    const handleGenderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedGender(event.target.value);
    };

    const handleNextStep = async () => {
        setRequiredFiledError(false);

        if (currentStep === 2) {
            if (!name) {
                setRequiredFiledError(true);
                return;
            }

            setCurrentStep((prevState) => prevState + 1);
        }

        if (currentStep === 3) {
            if (!yearOfBirth) {
                setRequiredFiledError(true);
                return;
            }
            const age = yearOfBirth ? new Date().getFullYear() - yearOfBirth : 0;

            if (age < 30 || age > 80) {
                setErrorMessage(t("Age Error"));
                return;
            }

            setCurrentStep((prevState) => prevState + 1);
        }

        if (currentStep === 4) {

            if (!selectedGender) {
                setRequiredFiledError(true);
                return;
            }

            if (selectedGender === 'Male') {
                setErrorMessage(t("Sex Error"));
                return;
            }

            try {
                setLoaderIsActive(true);

                const response = await axios.post(
                    config.API_URL_FOR_LOCAL_DEVELOPMENT + '/api/v1/landing/user/store',
                    {
                        language: config.LANGUAGE,
                        session: config.SESSION,
                        name,
                        yearOfBirth,
                        genderAtBirth: selectedGender,
                        source: 'Web'
                    }
                );

                window.localStorage.setItem('landingUserId', response.data.id);
                window.localStorage.setItem('name', name);

                props.setRegistrationData({
                    name,
                    yearOfBirth,
                    genderAtBirth: selectedGender
                })
                props.setRegistrationFormFilled(true);
                props.nextStep(1);
            } catch (error) {
                console.error('Error while sending data:', error);
            } finally {
                setLoaderIsActive(false);
            }
        }
    }

    const handleNameChange = (value: string): void => {
        setName(value.replace(/[^a-zA-ZÀ-ÿ\s]/g, ''));
    }

    useEffect(() => {
        if (props.registrationFormFilled) {
            setCurrentStep(4);

            if (props.registrationData) {
                setName(props.registrationData.name);
                setYearOfBirth(props.registrationData.yearOfBirth);
                setSelectedGender(props.registrationData.genderAtBirth);
            }
        }
    }, [])

    return (
        <div className='RegistrationMobile'>

            {
                !errorMessage &&
                <div className='nav-container position-relative'>

                    <div className='w-100'>
                        {
                            currentStep === 1 &&
                            <div className="step-1 text-center mb-3">
                                <img
                                    className='large-logo mb-3'
                                    src={largeLogo2}
                                />

                                <p>{t('Registration Content')}</p>
                            </div>
                        }

                        {
                            currentStep === 2 &&
                            <div className="step-2 text-center">
                                <img
                                    className='mb-2'
                                    src={logo2}
                                />

                                <label className='w-100 text-start mb-2'>
                                    <div className='mb-1'>{props.fields["name"].label}</div>

                                    <input
                                        className='input-1 w-100 mr-2'
                                        value={name}
                                        onChange={(e) => handleNameChange(e.target.value)}
                                        type="text"
                                        required={props.fields.name.required}
                                    />
                                </label>

                                {
                                    props.fields.name.tooltip &&
                                    <div className='hint-1 text-start mb-2'>
                                        {props.fields.name.tooltip}
                                    </div>
                                }
                            </div>
                        }

                        {
                            currentStep === 3 &&
                            <div className="step-3 text-center">
                                <img
                                    className='mb-2'
                                    src={logo2}
                                />

                                <label className='w-100 text-start mb-2'>
                                    <div className='mb-1'>{props.fields.yearOfBirth.label}</div>

                                    <input
                                        className='input-1 w-100 mr-2'
                                        value={yearOfBirth}
                                        onChange={(e) => setYearOfBirth(parseInt(e.target.value))}
                                        type="number"
                                        min='1940'
                                        max={new Date().getFullYear()}
                                        step='1'
                                        required={props.fields.yearOfBirth.required}
                                    />
                                </label>

                                {
                                    props.fields.yearOfBirth.tooltip &&
                                    <div className="hint-1 text-start mb-2">
                                        {props.fields.yearOfBirth.tooltip}
                                    </div>
                                }
                            </div>
                        }

                        {
                            currentStep === 4 &&
                            <div className='step-4 text-center'>
                                <img
                                    className='mb-2'
                                    src={logo2}
                                />

                                <div className='mb-2 text-start'>
                                    <div className='gender-at-birth-label label-1 mr-0'>
                                        {props.fields.genderAtBirth.label}
                                    </div>

                                    <label className='d-flex mb-1'>
                                        <input
                                            className='d-none'
                                            type="radio"
                                            name="gender"
                                            value="Female"
                                            checked={selectedGender === 'Female'}
                                            onChange={(e) => handleGenderChange(e)}
                                        />

                                        <div
                                            className={selectedGender === 'Female' ? 'checkbox-1 checkbox-1--checked mr-15' : 'checkbox-1 mr-15'}
                                            role='button'
                                        ></div>

                                        <span role='button'>{props.fields.genderAtBirth.options['Female']}</span>
                                    </label>

                                    <label className='d-flex'>
                                        <input
                                            className='d-none'
                                            type="radio"
                                            name="gender"
                                            value="Male"
                                            checked={selectedGender === 'Male'}
                                            onChange={(e) => handleGenderChange(e)}
                                        />

                                        <div
                                            className={selectedGender === 'Male' ? 'checkbox-1 checkbox-1--checked mr-15' : 'checkbox-1 mr-15'}
                                            role='button'
                                        ></div>

                                        <span role='button'>{props.fields.genderAtBirth.options['Male']}</span>
                                    </label>
                                </div>

                                {
                                    props.fields.genderAtBirth.tooltip &&
                                    <div className="hint-1 mb-15 text-start">
                                        {props.fields.yearOfBirth.tooltip}
                                    </div>
                                }

                                <div className='gender-error mb-2 text-start'>
                                    {t('Wrong Sex Error')}
                                </div>
                            </div>
                        }
                    </div>


                    <div>
                        {
                            requiredFiledError &&
                            <div className="error-message mb-2">{t('Complete the required field')}</div>
                        }

                        {
                            currentStep !== 1 &&
                            <div className='d-flex justify-content-center'>
                                <button
                                    onClick={() => setCurrentStep((prevState) => prevState - 1)}
                                    className="button-1 mr-4"
                                >
                                    {t("Back Button")}
                                </button>

                                <button
                                    onClick={() => handleNextStep()}
                                    className="button-1"
                                >
                                    {t("Continue Button")}
                                </button>
                            </div>
                        }

                        {
                            currentStep === 1 &&
                            <div className='d-flex justify-content-center'>
                                <button
                                    onClick={() => setCurrentStep(2)}
                                    className="button-1"
                                >
                                    Start
                                </button>
                            </div>
                        }
                    </div>

                    {loaderIsActive && <div className='submitting-overlay'></div>}
                </div>
            }

            {
                errorMessage &&
                <div className='error-message-box text-center'>
                    <div>
                        <img
                            className='mb-4'
                            src={logo2}
                        />

                        <p className='text-1 fw-bold mb-3'>Based on the information you provided, we are unable to continue.</p>

                        <p className='error-massage'>{errorMessage}</p>
                    </div>

                    <div className='d-flex justify-content-center'>
                        <button
                            onClick={() => setErrorMessage(null)}
                            className="button-1 mr-4"
                        >
                            {t("Back Button")}
                        </button>

                        <button
                            onClick={() => setErrorMessage(null)}
                            className="button-1"
                        >
                            {t("Continue Button")}
                        </button>
                    </div>
                </div>
            }
        </div>
    )
}

export default RegistrationMobile;